<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 哮天系统
                </el-breadcrumb-item>
				<el-breadcrumb-item>营销策略</el-breadcrumb-item>
				<el-breadcrumb-item> 邮件计划 </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.templateId" placeholder="请选择邮件模板">
					<el-option key="" label="请选择" value=""></el-option>
					<el-option v-for="item in templateKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>
				&nbsp;&nbsp;
				<el-select v-model="query.status" placeholder="请选择状态">
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option key="0" label="启动" value="0"></el-option>
					<el-option key="1" label="禁用" value="1"></el-option>
				</el-select>
				&nbsp;&nbsp;
                <el-input v-model="query.name" placeholder="请输入计划名称" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="name" label="计划名称"></el-table-column>
                <el-table-column prop="templateId" label="邮件模板" :formatter="mailTemplateFormat"></el-table-column>
				<el-table-column prop="status" label="状态">
					<template slot-scope="scope">
						{{scope.row.status==0?"启用":"禁用"}}
					</template>
				</el-table-column>
				<el-table-column prop="execTime" label="最新执行时间"></el-table-column>
				<el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit'] && JSON.parse(scope.row.sendPlan)['sendFrequency'] > 0"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if="controll['delete-batch']"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="60%">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-tabs v-model="activeName" type="card">
					<el-tab-pane label="邮件信息" name="baseTab">
						<el-form-item label="计划名称" prop="name">
							<el-input v-model="form.name"></el-input>
						</el-form-item>
						<el-form-item label="邮件模板" prop="templateId">
							<el-select v-model="form.templateId" placeholder="邮件模板">
								<el-option key="" label="请选择" value=""></el-option>
								<el-option v-for="item in templateKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="是否启动">
							<el-switch v-model="form.start"></el-switch>
						</el-form-item>
						<el-form-item label="备注">
							<el-input type=textarea :rows=8 v-model="form.remark"> </el-input>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="接收对象" name="receiveTab">
						<el-form-item label="对象类型" prop="receiveType">
							<el-radio v-model="receive.receiveType" label="appoint">指定接收邮箱</el-radio>
							<el-radio v-model="receive.receiveType" label="filter">筛选目标资源客户</el-radio>
							<el-radio v-model="receive.receiveType" label="accurate">精准客户(对邮件统计用户)</el-radio>
						</el-form-item>
						<el-form-item label="指定公司名称" v-if="receive.receiveType=='filter'">
							<el-input v-model="receive.filter.name" placeholder="公司名称" class="handle-input mr10"></el-input>
						</el-form-item>
						<el-form-item label="只发企业邮箱" v-if="receive.receiveType=='filter'">
							<el-switch v-model="receive.filter.companyEmailOnly"></el-switch>
						</el-form-item>
						<el-form-item label="指定分值区间" v-if="receive.receiveType=='filter'">
							<el-input v-model="receive.filter.minScore" placeholder="最小分值" class="handle-input mr10"></el-input> - 
							&nbsp;&nbsp;<el-input v-model="receive.filter.maxScore" placeholder="最大分值" class="handle-input mr10"></el-input>
						</el-form-item>
						<el-form-item label="指定区域" v-if="receive.receiveType=='filter'">
							<el-select v-model="receive.filter.provinceId" placeholder="请选择省" filterable @change="provinceChange">
								<el-option key="" label="请选择省" value=""></el-option>
								<el-option v-for="item in provinceKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>&nbsp;
							<el-select v-model="receive.filter.cityId" placeholder="请选择城市" filterable @change="cityChange">
								<el-option key="" label="请选择城市" value=""></el-option>
								<el-option v-for="item in cityKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>&nbsp;
							<el-select v-model="receive.filter.areaId" placeholder="请选择区域">
								<el-option key="" label="请选择区域" value=""></el-option>
								<el-option v-for="item in areaKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="指定公司类型" v-if="receive.receiveType=='filter'">
							<el-select v-model="receive.filter.resourcesType" placeholder="请选择公司类型">
								<el-option key="" label="请选择公司类型" value=""></el-option>
								<el-option v-for="item in customerTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>
						</el-form-item>
						<el-row v-if="receive.receiveType=='filter'">
							<el-col :span="8">
								<el-form-item label="邮箱过滤">
									<el-select v-model="receive.filter.emailFilterType" placeholder="请选择过滤方式">
										<el-option key="" label="请选择过滤方式" value=""></el-option>
										<el-option v-for="item in emailFilterType" :key="item.key" :label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-input v-model="receive.filter.emailKeys" placeholder="关键字,逗号分隔" style="width:80%;padding-left:10px;"></el-input>
							</el-col>
						</el-row>
						<el-form-item label="指定状态" v-if="receive.receiveType=='filter'">
							<el-select v-model="receive.filter.status" placeholder="请选择状态">
								<el-option key="" label="请选择状态" value=""></el-option>
								<el-option key="2" label="数据分析完成" value = "2"></el-option>
								<el-option key="3" label="已发信息" value = "3"></el-option>
								<el-option key="4" label="已成好友" value = "4"></el-option>
								<el-option key="5" label="已沟通" value = "5"></el-option>
								<el-option key="6" label="已合作" value = "6"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="设备关键字"  v-if="receive.receiveType=='filter'" prop="resourcesKeys">
							<el-select v-model="filterKeyId" placeholder="请选择关键字" filterable style="width:180px">
								<el-option key="" label="请选择关键字" value=""></el-option>
								<el-option v-for="item in resourcesKeyKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>&nbsp;&nbsp;
							<el-button type="primary" icon="el-icon-add" @click="addFilterKeys">添加</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
							<el-tag
								v-for="tag in filterKeyTags"
								:key="tag"
								class="mx-1"
								closable
								:disable-transitions="false"
								@close="filterTagClose(tag)"
								size="large"
								style="margin-bottom:20px;margin-right:10px;"
							  >
								{{ tag.value}}
							</el-tag>
						</el-form-item>
						<el-form-item label="邮箱地址"  v-if="receive.receiveType=='appoint'" prop="mailTos">
							<el-input type=textarea :rows=14 v-model="receive.appoint.mailTos" placeholder="多个邮箱用','分割, 最多50个"> </el-input>
						</el-form-item>
						<el-row v-if="receive.receiveType=='accurate'">
							<el-col :span="8">
								<el-form-item label="邮箱过滤">
									<el-select v-model="receive.accurate.emailFilterType" placeholder="请选择过滤方式">
										<el-option key="" label="请选择过滤方式" value=""></el-option>
										<el-option v-for="item in emailFilterType" :key="item.key" :label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-input v-model="receive.accurate.emailKeys" placeholder="关键字,逗号分隔" style="width:80%;padding-left:10px;"></el-input>
							</el-col>
						</el-row>
						<el-form-item label="历史记录过滤" v-if="receive.receiveType=='accurate'">
							<el-select v-model="receive.accurate.sendSuccess" style="width:160px" placeholder="发送结果过滤">
								<el-option key="" label="请选择发送结果" value=""></el-option>
								<el-option key="true" label="发送成功" value="true"></el-option>
								<el-option key="false" label="发送失败" value="false"></el-option>
							</el-select>
							&nbsp;
							<el-select v-model="receive.accurate.readed" style="width:160px" placeholder="阅读过滤">
								<el-option key="" label="请选择是否阅读" value=""></el-option>
								<el-option key="true" label="有阅读" value="true"></el-option>
								<el-option key="false" label="未阅读" value="false"></el-option>
							</el-select>
							&nbsp;
							<el-select v-model="receive.accurate.visitWebsite" style="width:160px" placeholder="官网访问过滤">
								<el-option key="" label="请选择是否访问官网" value=""></el-option>
								<el-option key="true" label="已访问" value="true"></el-option>
								<el-option key="false" label="未访问" value="false"></el-option>
							</el-select>
							&nbsp;
							<el-select v-model="receive.accurate.visitProduct" style="width:160px" placeholder="产品访问过滤">
								<el-option key="" label="请选择是否访问产品" value=""></el-option>
								<el-option key="true" label="已访问" value="true"></el-option>
								<el-option key="false" label="未访问" value="false"></el-option>
							</el-select>
						</el-form-item>
						<!-- <el-row>
							<el-col :span="7">
								<el-form-item label="阅读量(≥)" v-if="receive.receiveType=='accurate'">
									<el-input v-model="receive.accurate.readTimes" placeholder="阅读量"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="7">
								<el-form-item label="官网访问量(≥)" v-if="receive.receiveType=='accurate'">
									<el-input v-model="receive.accurate.visitWebsiteTimes" placeholder="访问量"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="7">
								<el-form-item label="产品查看量(≥)" v-if="receive.receiveType=='accurate'">
									<el-input v-model="receive.accurate.visitProductTimes" placeholder="查看量"></el-input>
								</el-form-item>
							</el-col>
						</el-row> -->
						<el-form-item label="设备关键字"  v-if="receive.receiveType=='accurate'" prop="resourcesKeys">
							<el-select v-model="accurateKeyId" placeholder="请选择关键字" filterable style="width:180px">
								<el-option key="" label="请选择关键字" value=""></el-option>
								<el-option v-for="item in resourcesKeyKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>&nbsp;&nbsp;
							<el-button type="primary" icon="el-icon-add" @click="addAccurateKeys">添加</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
							<el-tag
								v-for="tag in accurateKeyTags"
								:key="tag"
								class="mx-1"
								closable
								:disable-transitions="false"
								@close="accurateTagClose(tag)"
								size="large"
								style="margin-bottom:20px;margin-right:10px;"
							  >
								{{ tag.value}}
							</el-tag>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="发送计划" name="planTab">
						<el-form-item label="发送方式" prop="sendFrequency">
							<el-select v-model="plan.sendFrequency" placeholder="请选择发送方式" @change="frequencyChange">
								<el-option key="" label="请选择" value=""></el-option>
								<el-option key="0" label="即时发送" value = "0"></el-option>
								<el-option key="1" label="发送一次" value = "1"></el-option>
								<el-option key="2" label="每周发送" value = "2"></el-option>
								<el-option key="3" label="每月发送" value = "3"></el-option>
								<el-option key="4" label="每年发送" value = "4"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="发送日期" v-if="plan.sendFrequency=='1'">
							<el-date-picker
									type="date"
									placeholder="发送日期"
									v-model="plan.sendDate"
									value-format="yyyy-MM-dd"
							></el-date-picker>
						</el-form-item>
						<el-form-item label="邮件有效天数" v-if="plan.sendFrequency=='1'">
							<el-input v-model="plan.validDays" placeholder="邮件有效天数，生成后，需在指定的有效天数内发出，过期不发送，默认3天" class="handle-input mr10"></el-input>
						</el-form-item>
						<el-form-item label="发送星期" v-if="plan.sendFrequency=='2'">
							<el-select v-model="plan.weekDay" placeholder="请选择星期">
								<el-option key="" label="请选择" value=""></el-option>
								<el-option key="1" label="星期一" value = "1"></el-option>
								<el-option key="2" label="星期二" value = "2"></el-option>
								<el-option key="3" label="星期三" value = "3"></el-option>
								<el-option key="4" label="星期四" value = "4"></el-option>
								<el-option key="5" label="星期五" value = "5"></el-option>
								<el-option key="6" label="星期六" value = "6"></el-option>
								<el-option key="7" label="星期天" value = "7"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="发送日期" v-if="plan.sendFrequency>2">
							<div v-if="plan.sendFrequency=='4'" style="float:left">
								<el-select v-model="plan.month" placeholder="请选择月份" @change="monthChange">
									<el-option key="" label="请选择" value=""></el-option>
									<el-option key="0" label="一月" value = "0"></el-option>
									<el-option key="1" label="二月" value = "1"></el-option>
									<el-option key="2" label="三月" value = "2"></el-option>
									<el-option key="3" label="四月" value = "3"></el-option>
									<el-option key="4" label="五月" value = "4"></el-option>
									<el-option key="5" label="六月" value = "5"></el-option>
									<el-option key="6" label="七月" value = "6"></el-option>
									<el-option key="7" label="八月" value = "7"></el-option>
									<el-option key="8" label="九月" value = "8"></el-option>
									<el-option key="9" label="十月" value = "9"></el-option>
									<el-option key="10" label="十一月" value = "10"></el-option>
									<el-option key="11" label="十二月" value = "11"></el-option>
								</el-select> &nbsp;
							</div>
							<el-select v-model="plan.date" placeholder="请选择日期" v-if="plan.sendFrequency>2"  style="float:left">
								<el-option key="" label="请选择" value=""></el-option>
								<el-option v-for="item in dateKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="最迟有效期" v-if="plan.sendFrequency >2">
							<div v-if="plan.sendFrequency=='4'" style="float:left">
								<el-select v-model="plan.validMonth" placeholder="请选择月份" @change="validMonthChange">
									<el-option key="" label="请选择" value=""></el-option>
									<el-option key="0" label="一月" value = "0"></el-option>
									<el-option key="1" label="二月" value = "1"></el-option>
									<el-option key="2" label="三月" value = "2"></el-option>
									<el-option key="3" label="四月" value = "3"></el-option>
									<el-option key="4" label="五月" value = "4"></el-option>
									<el-option key="5" label="六月" value = "5"></el-option>
									<el-option key="6" label="七月" value = "6"></el-option>
									<el-option key="7" label="八月" value = "7"></el-option>
									<el-option key="8" label="九月" value = "8"></el-option>
									<el-option key="9" label="十月" value = "9"></el-option>
									<el-option key="10" label="十一月" value = "10"></el-option>
									<el-option key="11" label="十二月" value = "11"></el-option>
								</el-select>&nbsp;
							</div>
							<el-select v-model="plan.validDate" placeholder="请选择日期" >
								<el-option key="" label="请选择" value=""></el-option>
								<el-option v-for="item in validDateKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>
							<br>
							<font color="red">发送日期是邮件启动发送的时间，如遇突发原因邮件没有发送成功时，系统会在有效期内重新发送，过了有效期则放弃发送，所以有效期建议不超过内容时间。<br/>如：国庆节邮件最迟不能超过十月一日</font>
						</el-form-item>
					</el-tab-pane>
				</el-tabs>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchMarketingMailPlanData, saveMarketingMailPlan, deleteMarketingMailPlan, getMarketingMailPlan, getMarketingMailTemplateKV, 
getAreaKv, getPotentialResourcesKeyByType} from '../../../api/index';
export default {
    name: 'market-mail-plan',
    data() {
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			title:"",
			rules: {
                templateId: [{ required: true, message:'请选择模板', trigger: 'blur' }],
                name: [{ required: true, message: '请输入计划名称', trigger: 'blur' }]
            },
			templateKV : [],
			activeName : "baseTab",
			plan:{},
			receive:{"appoint":{}, "filter":{}, "accurate":{}},
			customerTypeKV:[{"key":0,"value":"元器件生产商"},{"key":1,"value":"元器件经销商"},{"key":2,"value":"设备生产商"},{"key":3,"value":"设备经销商"},{"key":4,"value":"未知生产商"},{"key":5,"value":"未知经销商"}],
			dateKV:[],
			areaKV:[],
			cityKV:[],
			provinceKV:[],
			validDateKV:[],
			controll:{},
			emailFilterType:[{"key":"include","value":"包含关键字"}, {"key":"exclude","value":"剔除关键字"}],
			resourcesKeyKV:{},
			filterKeyTags:[],
			accurateKeyTags:[],
			filterKeyId:"",
			accurateKeyId:""
        };
    },
    created() {
		this.controll = getControll("market-mail-plan");
        this.getData();
		this.getMailTemplate();
		this.getAreaKV(0, 0);
		this.getResourceKey();
    },
    methods: {
		addFilterKeys() {
			this.addKeys(this.filterKeyId, this.filterKeyTags);
		},
		addAccurateKeys() {
			this.addKeys(this.accurateKeyId, this.accurateKeyTags);
		},
		filterTagClose(tag) {
			this.tagClose(this.filterKeyTags, tag);
		},
		accurateTagClose(tag) {
			this.tagClose(this.accurateKeyTags, tag);
		},
		addKeys(keyId, keyTags) {
			if (keyId == "" || keyId == undefined) {
				this.$message.error("请选择设备关键字!");
				return;
			}
			let index = keyTags.findIndex(item => {
				if (item.key === keyId) {
					return true;
				}
			});
			if (index === -1) {
				index = this.resourcesKeyKV.findIndex(item => {
					if (item.key === keyId) {
						return true;
					}
				});
				if (index == -1) return;
				keyTags.push(this.resourcesKeyKV[index])
			};
		},
		tagClose(keyTags, tag){
			let index = keyTags.findIndex(item => {
				if (item.key === tag.key) {
					return true;
				}
			});
			if (index > -1) {
				keyTags.splice(index, 1);
			}
		},
		getResourceKey() {
			getPotentialResourcesKeyByType(0).then(res => {
				if (res.code == 0) {
					this.resourcesKeyKV = res.data;
				} else {
					this.$message.error(`获取关键字失败！` + res.message);
				}
			});
		},
		//省变更
		provinceChange(value) {
			this.$set(this.form, 'cityId', '');
			this.areaKV = [];
			this.cityKV = [];
			if (value == "") return;
			this.getAreaKV(value, 1);
		},
		//市变更
		cityChange(value) {
			this.areaKV = [];
			this.$set(this.form, 'areaId', '');
			if (value == "") return;
			this.getAreaKV(value, 2);
		},
		//获取省市区
		getAreaKV(parentId, type) {
			getAreaKv(parentId).then(res => {
				if (res.code == 0 ) {
					if (type == 0) {
						this.provinceKV = res.data;
					} else if (type == 1){
						this.cityKV = res.data;
					} else if (type == 2){
						this.areaKV = res.data;
					}
				} else {
					this.$message.error("获取区域信息失败！" + res.message);
				}
			});
		},
		//模式变更
		frequencyChange(val) {
			this.$set(this.plan, "date", "");
			this.$set(this.plan, "weekDay", "");
			this.$set(this.plan, "month", "");
			this.$set(this.plan, "validDate", "");
			this.$set(this.plan, "validMonth", "");
			this.$set(this.plan, "sendDate", "");
			if (val == "") {
				return;
			}
			this.dateKV = [];
			this.validDateKV = [];
			if (val == 3) {
				let item = {};
				this.buildDate(31);
				this.buildValidDate(31);
			}
		},
		//发送月份变更
		monthChange(val) {
			this.$set(this.plan, "date", "");
			if (val == "") {
				this.dateKV = [];
				return;
			}
			if (val == 1) {
				this.buildDate(28);
			} else if (val == 0 || val == 2 || val == 4 || val == 6 || val == 7 || val == 9 || val == 11) {
				this.buildDate(31);
			} else {
				this.buildDate(30);
			}
		},
		//有效期月份变更
		validMonthChange(val) {
			this.$set(this.plan, "validDate", "");
			if (val == "") {
				this.validDateKV = [];
				return;
			}
			if (val == 1) {
				this.buildValidDate(28);
			} else if (val == 0 || val == 2 || val == 4 || val == 6 || val == 7 || val == 9 || val == 11) {
				this.buildValidDate(31);
			} else {
				this.buildValidDate(30);
			}
		},
		//构建发送日期
		buildDate(size) {
			for (var i = 1; i <= size; i++) {
				let item = {};
				item["key"] = i;
				item["value"] = i + "日";
				this.dateKV.push(item);
			}
		},
		//构建有效日期
		buildValidDate(size) {
			for (var i = 1; i <= size; i++) {
				let item = {};
				item["key"] = i;
				item["value"] = i + "日";
				this.validDateKV.push(item);
			}
		},
		getMailTemplate(){
			getMarketingMailTemplateKV().then(res => {
				if (res.code == 0 ) {
					this.templateKV = res.data;
				} else {
					this.$message.error("获取模板数据失败！" + res.message);
				}
			});
		},
		mailTemplateFormat(row, column, cellValue) {
			let index = this.templateKV.findIndex(item => {
			if (item.key === cellValue) {
				return true;
			}
			});
			if (index === -1) return cellValue;
			return this.templateKV[index].value;
		},
        // 获取数据
        getData() {
            fetchMarketingMailPlanData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteMarketingMailPlan([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteMarketingMailPlan(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.title = "添加新纪录";
			this.$set(this.receive, "receiveType", "appoint");
			this.filterKeyTags = [];
			this.accurateKeyTags = [];
			this.plan = {};
			this.activeName = "baseTab";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
			this.title = "编辑";
			this.activeName = "baseTab";
			getMarketingMailPlan(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.$set(this.form, 'start', res.data.status==0);
					if (res.data.filterCondition != undefined) {
						this.receive = JSON.parse(res.data.filterCondition);
					}
					if (res.data.sendPlan != undefined) {
						this.plan = JSON.parse(res.data.sendPlan);
					}
					this.filterKeyTags = [];
					this.accurateKeyTags = [];
					if (this.receive.filter["resourcesKeyIds"] != undefined) {
						for (var i = 0; i < this.receive.filter["resourcesKeyIds"].length; i++) {
							let index = this.resourcesKeyKV.findIndex(item => {
								if (item.key === this.receive.filter["resourcesKeyIds"][i]) {
									return true;
								}
							});
							if (index == -1) return;
							this.filterKeyTags.push(this.resourcesKeyKV[index]);
						}
					} 
					if (this.receive.accurate["resourcesKeyIds"] != undefined) {
						for (var i = 0; i < this.receive.accurate["resourcesKeyIds"].length; i++) {
							let index = this.resourcesKeyKV.findIndex(item => {
								if (item.key === this.receive.accurate["resourcesKeyIds"][i]) {
									return true;
								}
							});
							if (index == -1) return;
							this.accurateKeyTags.push(this.resourcesKeyKV[index]);
						}
					}
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
		validateEmail(mail) {
			const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // 邮箱格式的正则表达式
			return regex.test(mail); // 判断邮箱是否符合要求并更新isEmailValid状态
		},
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					if (this.receive["receiveType"] == "appoint") {
						if (this.receive.appoint["mailTos"] == undefined) {
							this.$message.error(`请输入邮箱地址！`);
							return;
						}
						let mailTos = this.receive.appoint["mailTos"].split(",");
						if (mailTos.length > 50) {
							this.$message.error(`邮箱地址最多只能支持50个！`);
							return;
						}
						for (var i = 0; i < mailTos.length; i++) {
							if (!this.validateEmail(mailTos[i])) {
								this.$message.error(`请输入正确的邮箱地址！`);
								return;
							}
						}
					}
					else if (this.receive["receiveType"] == "filter") {
						if (this.receive.filter["emailFilterType"] != undefined && this.receive.filter["emailFilterType"] != "" && (this.receive.filter["emailKeys"] == undefined || this.receive.filter["emailKeys"] == "")) {
							this.$message.error(`请输入邮箱过滤关键字！`);
							return;
						}
						if (this.filterKeyTags.length > 0) {
							let resourcesKeyIds = [];
							for (var i = 0; i < this.filterKeyTags.length; i++) {
								resourcesKeyIds.push(this.filterKeyTags[i].key);
							}
							this.receive.filter["resourcesKeyIds"] = resourcesKeyIds;
						}
					} else if (this.receive["receiveType"] == "accurate") {
						if (this.receive.accurate["emailFilterType"] != undefined && this.receive.accurate["emailFilterType"] != "" && (this.receive.accurate["emailKeys"] == undefined || this.receive.accurate["emailKeys"] == "")) {
							this.$message.error(`请输入邮箱过滤关键字！`);
							return;
						}
						if (this.accurateKeyTags.length > 0) {
							let resourcesKeyIds = [];
							for (var i = 0; i < this.accurateKeyTags.length; i++) {
								resourcesKeyIds.push(this.accurateKeyTags[i].key);
							}
							this.receive.accurate["resourcesKeyIds"] = resourcesKeyIds;
							delete this.receive.filter["resourcesKeyIds"];
						}
					}
					if (this.plan.sendFrequency == undefined || this.plan.sendFrequency == "") {
						this.$message.error(`请选择发送方式！`);
						return;
					}
					if (this.plan.sendFrequency == "0" && !this.form.start) {
						this.$message.error(`即时发送，请将状态设为启动！`);
						return;
					}
					if (this.plan.sendFrequency == "1" && this.plan.sendDate == "") {
						this.$message.error(`请选择发送日期！`);
						return;
					}
					if (this.plan.sendFrequency == "2" && this.plan.weekDay == "") {
						this.$message.error(`请选择每周发送的日期！`);
						return;
					}
					if (this.plan.sendFrequency == "3") {
						if (this.plan.date == "") {
							this.$message.error(`请选择每月发送的日期！`);
							return;
						} else if (this.plan.validDate == "") {
							this.$message.error(`请选择每月发送的有效期！`);
							return;
						} else if (this.plan.date * 1 > this.plan.validDate * 1) {
							this.$message.error(`有效期不能比发送日期小！`);
							return;
						}
					}
					if (this.plan.sendFrequency == "4") {
						if (this.plan.month == "" || this.plan.date == "") {
							this.$message.error(`请选择每年发送的日期！`);
							return;
						} else if (this.plan.validMonth == "" || this.plan.validDate == "") {
							this.$message.error(`请选择每年发送的有效期！`);
							return;
						} else if (this.plan.month * 30 + this.plan.date > this.plan.validMonth * 30 + this.plan.validDate) {
							this.$message.error(`有效期不能比发送日期小！`);
							return;
						}
					}
					this.form.filterCondition = JSON.stringify(this.receive);
					this.form.sendPlan = JSON.stringify(this.plan);
					this.form.status = this.form.start?0:1;
					
					if (this.plan.sendFrequency == "0") {
						this.$confirm('你选择着了即时发送，邮件计划保存时将同时发送，确定保存吗？', '提示', {
							type: 'warning'
						})
							.then(() => {
								this.savePlan(this.form);
							})
							.catch(() => {});
					} else {
						this.savePlan(this.form);
					}
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }, 
		savePlan(data) {
			saveMarketingMailPlan(data).then(res => {
				if (res.code == 0) {
					this.$message.success('保存成功！');
					this.editVisible = false;
					this.getData();
				} else {
					this.$message.error(`保存失败！` + res.message);
				}
			})
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
